import { FundOverrideItem } from "~/models/fund";

export const findFundOverrideImage = (
  fundOverrides: FundOverrideItem[],
  ein: string
) => {
  const fundOverride = fundOverrides.find((override) => override.ein === ein);
  console.log("findFundOverrideImage", ein, fundOverride);
  return fundOverride?.imageId;
};

// I originally tried to declare an array in block.json to hold the overrides,
// but the "save" function wouldn't serialize it correctly. I reverted to using a string
// and parsing/stringifying it manually.
export const parseFundOverrides = (
  fundOverridesStr?: string
): FundOverrideItem[] => {
  if (!fundOverridesStr) return [];

  try {
    const fundOverrides: FundOverrideItem[] = JSON.parse(fundOverridesStr);
    return fundOverrides;
  } catch (error) {
    console.error("Error parsing fundOverrides:", error);
    return [];
  }
};

export const stringifyFundOverrides = (
  fundOverrides: FundOverrideItem[]
): string => {
  return JSON.stringify(fundOverrides);
};
